// Module
var code = "<bringoz-button [ngbTooltip]=\"'View Settings'\" (on-click)=\"$ctrl.onShowPanel($event)\" type=\"tertiary\"> <bringoz-icon icon-name=\"settings\"></bringoz-icon> </bringoz-button> ";
// Exports
export default code;